import ruLocale from 'element-ui/lib/locale/lang/ru-RU'
import home from './ru/home'

const ru = {
    language: 'Русский',
    message: {
        'home': home,
    },
    '手机号码最小长度为8位': '«Минимальная длина номера мобильного телефона — 8 цифр»',
    '邮箱账号名称最小长度为6位': '«Минимальная длина имени учетной записи электронной почты — 6 символов»',
    '邮箱只能包含英文，数字等字符': "«Почтовый ящик может содержать только такие символы, как английский язык и цифры»",
    '请选择正确的收货地址': '«Пожалуйста, выберите правильный адрес доставки»',
    ...ruLocale
}
export default ru
